import { DialogTitle, Divider } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";



export const ModalHeader=({title,onClose,closeIcon})=>{
    return (
      <>
        <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "auto",
            backgroundColor: "#C0BFFF",
            // padding: "10px 20px 10px 30px",
            padding: "16px 24px",
            fontFamily: "'Montserrat', sans-serif",
            borderRadius: "10px",
            fontSize: { xs: "12px", sm: "13px", md: "20px" },
             fontWeight: 500,
          }}
        >
          {title}{" "}
          {!closeIcon && (
            <CloseIcon
              sx={{ float: "left", cursor: "pointer" }}
              onClick={() => onClose(false)}
            />
          )}
        </DialogTitle>
        {/* <Divider /> */}
      </>
    );
}